import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";

const BaseDialog = (props) => {
  const { open, title, handleClose, content, actions } = props;
  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "300px", // ダイアログの最小幅
          minHeight: "200px", // ダイアログの最小高さ
        },
      }}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        {title}
        {/* ×ボタン */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>{content}</DialogContent>
      <Divider />
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};

const FormBaseDialog = (props) => {
  const { open, title, handleClose, content } = props;
  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "300px", // ダイアログの最小幅
          minHeight: "200px", // ダイアログの最小高さ
        },
      }}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        {title}
        {/* ×ボタン */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      {content}
    </Dialog>
  );
};

const ConfirmationDialog = (props) => {
  const {
    open,
    title,
    handleClose,
    handleSubmit,
    message,
    negativeText,
    positiveText,
  } = props;

  const actions = (
    <>
      <Button onClick={handleClose} color="primary">
        {negativeText ? negativeText : "Cancel"}
      </Button>
      <Button onClick={handleSubmit} color="primary">
        {positiveText ? positiveText : "OK"}
      </Button>
    </>
  );

  const content = (
    <>
      <Typography variant="h6">{`${message}`}</Typography>
    </>
  );
  return (
    <BaseDialog
      open={open}
      title={title}
      content={content}
      actions={actions}
      handleClose={handleClose}
    />
  );
};

const MessageDialog = (props) => {
  const { open, title, handleClose, message, actionText } = props;

  const actions = (
    <>
      <Button onClick={handleClose} color="primary">
        {actionText ? actionText : "OK"}
      </Button>
    </>
  );

  const content = (
    <>
      <Typography variant="h6">{`${message}`}</Typography>
    </>
  );
  return (
    <BaseDialog
      open={open}
      title={title}
      content={content}
      actions={actions}
      handleClose={handleClose}
    />
  );
};

const ProgressBackdropDialog = (props) => {
  const { open } = props;

  return (
    <Backdrop
      open={open}
      sx={{
        color: "#fff",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export {
  BaseDialog,
  FormBaseDialog,
  ConfirmationDialog,
  MessageDialog,
  ProgressBackdropDialog,
};
